import React from "react";
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

function AlertsDialog(props: { openDialog: boolean, setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>, handleAgreeClick: () => void, dialogTitle: string, dialogMessage: string, isWaitingResponse: boolean }): JSX.Element {
    const {
        openDialog,
        setOpenDialog,
        handleAgreeClick,
        dialogTitle,
        dialogMessage,
        isWaitingResponse
    } = props

    const { t } = useTranslation();

    return (
        <Dialog
            sx={{ zIndex: 1302 }}
            open={openDialog}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    setOpenDialog(false);
                }
            }}
            PaperProps={{
                style: { borderRadius: 20 }
            }}
        >
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                <DialogTitle id="alert-dialog-title">
                    {dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
                <Box borderTop={1} width="100%">
                    <Grid container>
                        <Grid item xs={6} display={"flex"} alignItems={"center"} justifyContent={"center"} style={{ borderRight: '1px solid rgb(0, 0, 0)' }}>
                            <Button disabled={isWaitingResponse} onClick={() => setOpenDialog(false)}>
                                {t('component.alertsDialog.cancel')}
                            </Button>
                        </Grid>
                        <Grid item xs={6} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                            <Button disabled={isWaitingResponse} onClick={() => handleAgreeClick()} autoFocus>
                                {t('component.alertsDialog.ok')}    
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Dialog>
    );
};

export default AlertsDialog;
